import React from 'react';
import { useTranslation } from 'react-i18next';
import { RegistrationRabenSchema } from '../../form';
import OneValueCheckboxField from 'src/components/CheckboxField';
import { CheckboxWrapper } from './index.styles';

export default function Consents(props: {
  form: RegistrationRabenSchema;
  setForm: React.Dispatch<React.SetStateAction<RegistrationRabenSchema>>;
}) {
  const { form, setForm } = props;
  const { t } = useTranslation();

  return (
    <CheckboxWrapper sx={{ mt: '10px', mb: '10px' }}>
      <OneValueCheckboxField
        label=""
        value={form.terms_of_service_consent}
        setValue={(value: boolean) =>
          setForm({ ...form, terms_of_service_consent: value })
        }
      />
      <span
        dangerouslySetInnerHTML={{
          __html: t(`registration_raben.form.terms_of_service_consent`),
        }}
        style={{
          fontSize: '12px',
          color: '#E30311',
          lineHeight: '18px',
        }}
      />
    </CheckboxWrapper>
  );
}
